import React, { useState } from "react";
import { Text, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import useNow from "../hooks/useNow";
import tw from "twrnc";
import { brandColor } from "../globalStyle";
import { t } from "@/localization";

export const ClockIcon = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <Path d="M12.727 4.477h-1.5v8.349l5.419 2.576.644-1.355-4.563-2.169V4.477z" />
    <Path d="M12 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75zm0 21c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75z" />
  </Svg>
);

const GoLiveButton = ({ goLive, event, contentBeforeReady, style }) => {
  const [goliveloading, setgoliveloading] = useState(false);

  const {
    stream_key,
    is_published,
    is_test,
    event_window_start_datetime_utc,
    event_window_end_datetime_utc,
    event_status,
  } = event;

  const now = useNow();

  const isAfter = now.isAfter(event_window_end_datetime_utc);

  const testExpired = is_test && isAfter;
  const eventNeverStreamed =
    isAfter && is_published && !is_test && event_status === "upcoming";

  const liveButtonTitle = is_test
    ? t("Start free test")
    : event_status === "upcoming"
    ? t("Go Live")
    : t("Continue");

  const buttonAction = async () => {
    await goLive();
  };

  return (
    <>
      {is_published && (
        <TouchableOpacity
          disabled={!!goliveloading}
          onPress={buttonAction}
          style={[
            tw`rounded-lg bg-[${brandColor}] px-10 py-4 mb-2.5 h-[62px] items-center justify-center flex-row`,
            !!goliveloading && tw`bg-gray-400`,
            style,
          ]}
        >
          {goliveloading && <ClockIcon fill="white" />}
          {!goliveloading && (
            <Ionicons
              name="videocam-outline"
              size={24}
              color="white"
              style={tw`mr-1.5`}
            />
          )}
          <Text style={tw`text-white text-base`}>{liveButtonTitle}</Text>
        </TouchableOpacity>
      )}

      {testExpired && (
        <Text style={tw`text-center self-center`}>
          {t("Test event expired. Please create a new one.")}
        </Text>
      )}

      {eventNeverStreamed && (
        <Text style={tw`text-center self-center`}>
          {t(
            "This event has not gone Live. Please reschedule in the settings."
          )}
        </Text>
      )}
    </>
  );
};

export default GoLiveButton;
